import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'

function selectBase(state) {
  return state.ai || emptyObj
}

export const selectInstantReplyAi = createBasicSelector(
  selectBase,
  base => base.instantReplyRequest || emptyObj
)

export const selectConversationRequestAi = createBasicSelector(
  selectBase,
  base => base.conversationRequest || emptyObj
)

export const selectComposerRequestAi = createBasicSelector(
  selectBase,
  base => base.composerRequest || emptyObj
)
